function DiscountIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="#FE980E"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18.9 8.58l-1-1c-.38-.38-.6-.9-.6-1.44V4.72c0-1.12-.9-2.04-2.04-2.04h-1.4c-.54 0-1.06-.22-1.44-.6l-1-1c-.8-.8-2.08-.8-2.88 0l-1 1c-.38.38-.9.6-1.44.6H4.68c-1.12 0-2.04.9-2.04 2.04v1.4c0 .54-.22 1.06-.6 1.44l-1 1c-.8.8-.8 2.08 0 2.88l1 1c.38.38.6.9.6 1.44v1.42c0 1.12.9 2.04 2.04 2.04h1.4c.54 0 1.06.22 1.44.6l1 1c.8.8 2.08.8 2.88 0l1-1c.38-.38.9-.6 1.44-.6h1.42c1.12 0 2.04-.9 2.04-2.04v-1.4c0-.54.22-1.06.6-1.44l1-1c.8-.8.8-2.1 0-2.88zM7.52 6.18c.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3-.72 0-1.32-.58-1.32-1.3 0-.72.58-1.3 1.32-1.3zm.38 7.06a.79.79 0 01-.56.24c-.2 0-.42-.08-.56-.24a.797.797 0 010-1.14l5.38-5.38c.32-.32.82-.32 1.14 0 .32.32.32.82 0 1.14l-5.4 5.38zm4.62.56c-.72 0-1.32-.58-1.32-1.3 0-.72.58-1.3 1.32-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3z" />
    </svg>
  )
}

export default DiscountIcon
